import { shiftRequest } from "../ShiftEarnings/shiftEarningsApi";

// List path of each pay input; activity is <path>/<record id>/activity/.
const PATHS = {
  SHIFT_EARNING: "payroll/earning/shift/earning_details",
  OVERTIME: "payroll/earning/overtime/earning_details",
  LEAVE: "payroll/earning/leave/earning_details",
  PENALTY: "payroll/deduction/penalty_details",
  // Loans & Advances (advance requests): GET advance/request/<id>/activity/,
  // confirmed by the backend's Loan & Advance Activity History API doc.
  LOAN_ADVANCE: "advance/request",
};

export const isSavedPayInputId = (id) => /^\d+$/.test(String(id)) && Number.isSafeInteger(Number(id)) && Number(id) > 0;

export const loadPayInputActivity = async (domain, type, recordId, { signal, action, fieldName } = {}) => {
  if (!PATHS[type]) throw new Error("Unsupported pay input activity type.");
  if (!isSavedPayInputId(recordId)) throw new Error("Activity is available for saved records only.");
  const params = new URLSearchParams();
  if (action) params.set("action", action);
  if (fieldName) params.set("field_name", fieldName);
  const query = params.toString();
  const data = await shiftRequest(domain, `${PATHS[type]}/${recordId}/activity/${query ? `?${query}` : ""}`, { signal });
  if (!Array.isArray(data)) throw new Error("Unable to read the activity log returned by the server.");
  // The backend supplies newest-first order. Exclude explicitly mismatched records.
  return data.filter((entry) =>
    entry && typeof entry === "object" &&
    (entry.pay_input_type == null || entry.pay_input_type === type) &&
    (entry.record_id == null || String(entry.record_id) === String(recordId)),
  ).map(toPayInputActivityEntry);
};

const shown = (value) => value == null || value === "" ? "–" : typeof value === "object" ? JSON.stringify(value) : String(value);
const labelFor = (name) => String(name).replace(/_/g, " ").replace(/\b\w/g, (letter) => letter.toUpperCase());

export const toPayInputActivityEntry = (entry) => ({
  id: entry.id,
  type: ({ Created: "created", Updated: "updated", "Status Changed": "status" })[entry.action] || "activity",
  title: entry.title || entry.action || "Activity",
  actor: {
    name: entry.performed_by_name || (entry.performed_by == null ? "System" : "Unknown user"),
    role: entry.performed_by_role || "",
  },
  at: entry.createdat,
  changes: entry.field_name ? [{
    label: entry.field_label || labelFor(entry.field_name),
    from: shown(entry.old_value),
    to: shown(entry.new_value),
  }] : [],
  note: entry.message || "",
});
